import { FunctionComponent, ReactNode } from "react";
import { AuthProvider } from "./auth";

interface AppProvider {
  children?: ReactNode;
}

const AppProvider: FunctionComponent<AppProvider> = ({ children }) => {
  return (
    //@ts-ignore
    <AuthProvider>{children}</AuthProvider>
  );
};
export default AppProvider;
